import authClient from './authClient';

export const advertiserLogin = (advertiserLoginData) => {
    return authClient.post(process.env.REACT_APP_API_URL + '/advertiserLogin', advertiserLoginData);
};